import React, { Component } from 'react'
import './Index.scss'
import DataHeader from './containers/DataHeader'
import DataTable from "./containers/DataTable"
import dataIcon from "app/styles/images/sp/data-selected.svg"
import { observer, Provider } from 'mobx-react'
import reportStore from 'app/stores/research/pgs/report'
@observer
export default class index extends Component {
  constructor(props) {
    super(props)
    this.reportStore = new reportStore()
    this.reportStore.setGroupId(props.match.params.id)
  }
  handleGoBack = () => {
    const { history } = this.props
    history.goBack()
  }
  render() {
    const { match, history, location } = this.props
    return (
      <Provider reportStore={this.reportStore}>
        <div className="datamanage-detail-page pgd">
          <h2 className="page-title">
            <img alt="" src={dataIcon} />
            <span
              className='go-back-span'
              onClick={this.handleGoBack}
            >
              PGS家系管理
            </span> > 报告列表
          </h2>
          <div className="clearfix wrapper-box-first">
            <DataHeader />
          </div>
          <div>
            <DataTable
              match={match}
              history={history}
              location={location}
            />
          </div>
        </div>
      </Provider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/research/pgs/data_manage_detail/index.js